import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { docNameFormatter } from '../../../utils/commonUtil';

import {
  DataHolder,
  Receipt,
  ReceiptDate,
  ReceiptTag,
  ReceiptNo,
  ReceiptAction,
  ReceiptActions,
  TooltipContainer,
} from './styles';

function TooltipComponent(props) {
  return (
    <>
      <TooltipContainer
        overlayClassName="contribution-overlay"
        className="contribution"
        placement="topLeft"
        title={props.title}
        autoAdjustOverflow={false}
      >
        {props.children}
      </TooltipContainer>
    </>
  );
}

function DocumentCard({ receipt, handleViewAnalytics, newIcon, indexKey, myDocument = false, docName = "" }) {
  return (
    <>
      <Receipt rMargin="20px" bMargin="0">
        <DataHolder>
          <ReceiptDate className="mt0">
            {moment(receipt.date).format('L')}
          </ReceiptDate>
          {newIcon && <ReceiptTag>NEW</ReceiptTag>}
        </DataHolder>
        <ReceiptNo className="dashboard">
          <TooltipComponent
            className="contribution"
            placement="topLeft"
            title={docNameFormatter(receipt.name)}
          >
            { docNameFormatter(receipt.name) }
          </TooltipComponent>
        </ReceiptNo>
        <ReceiptActions>
          <ReceiptAction
            // data-test="receipt-action"
            id={indexKey ? indexKey + "anrViewAndDownload" : "anrViewAndDownload"}
            href={receipt.link}
            target="_blank"
            onClick={() =>
              myDocument ? 
              handleViewAnalytics(
                receipt.docId,
                'Tax Receipts',
                'View & Download',
                docName
              ) : 
              handleViewAnalytics(
                'taxReceipts',
                'Tax Receipts',
                'View & Download',
                docName
              )
            }
          >
            View &amp; Download
          </ReceiptAction>
        </ReceiptActions>
      </Receipt>
    </>
  );
}

DocumentCard.propTypes = {
  receipt: PropTypes.shape({
    date: PropTypes.number,
    id: PropTypes.string,
    link: PropTypes.string,
    name: PropTypes.string,
  }),
  handleViewAnalytics: PropTypes.func,
};

export default DocumentCard;
